import styled from 'styled-components'

import { getColorByStatusCode } from '~/features/inquiry/utils/inquiry'
import Round from '~/shared/components/round/Round'
import theme from '~/shared/styles/theme'

type Props = {
  status: string
  desc: string
}

function ProccessStatus({ status, desc }: Props) {
  const color = getColorByStatusCode(status)

  return (
    <Wrapper>
      <StatusContainer>
        <StatusBox>
          <Round color={color} />
          <StatusText $color={color}>{desc}</StatusText>
        </StatusBox>
      </StatusContainer>
    </Wrapper>
  )
}

export default ProccessStatus

const Wrapper = styled.div`
  display: flex;
  gap: 24px;
  align-items: center;

  @media ${theme.device.medium} {
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 100%;
  }
`

const StatusContainer = styled.div`
  display: flex;
  gap: 24px;
  align-items: center;

  @media ${theme.device.medium} {
    flex-direction: column;
    gap: 12px;
    align-items: center;
    justify-content: center;

    width: 100%;
  }
`

const StatusBox = styled.div`
  display: flex;
  gap: 12px;
  align-items: center;
  justify-content: center;

  width: 156px;
  height: 49px;

  font-family: NanumSquareNeo-Bold, sans-serif;
  font-size: 18px;
  font-weight: 700;
  line-height: 25px;
  color: #838685;

  border: 1px solid #c1c3c2;
  border-radius: 12px;

  @media ${theme.device.medium} {
    width: 100%;
    height: 41px;
    font-size: 15px;
    line-height: 21px;
  }
`

const StatusText = styled.span<{ $color: string }>`
  color: ${({ $color }) => $color};

  @media ${theme.device.medium} {
    font-size: 15px;
    line-height: 21px;
  }
`
